<template>
  <div>
    <v-row v-if="myData.length > 0" no-gutters>
      <v-col cols="12">
        <v-row class="font-weight-black text-center" justify="space-between">
          <v-col cols="auto" align="start">
            <v-checkbox
              v-model="selectAll"
              class="ma-0 pa-0"
              @change="handleSelectAll"
            ></v-checkbox>
          </v-col>
          <v-col cols="1">项目编号</v-col>
          <v-col cols="2">合同编号</v-col>
          <v-col cols="2">剩余样本（合同约定保存三个月）</v-col>
          <v-col cols="2">截止日（三个月后自动销毁）</v-col>
          <v-col cols="1">状态</v-col>
          <v-col cols="1">操作</v-col>
        </v-row>
      </v-col>
      <template v-for="(item, i) in myData">
        <v-col :key="`divider_${i}`" cols="12"><v-divider /></v-col>
        <v-col
          cols="12"
          :key="`project_${i}`"
          class="caption pa-0 ma-0 text-center"
        >
          <project-row
            :item="item"
            :sendParams="sendParams"
            v-on="$listeners"
          />
        </v-col>
      </template>
    </v-row>

    <v-row v-else style="margin-top: 100px" justify="center">
      <v-col cols="auto" class="text-h3 orange--text">暂无数据</v-col>
    </v-row>
  </div>
</template>

<script>
import projectRow from "./projectRow.vue";
export default {
  components: {
    projectRow,
  },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    sendParams: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    handleSelectAll(val) {
      this.myData.forEach((item) => {
        item.isChecked = val;
      });
    },
    resetSelectAll() {
      this.selectAll = false;
    },
  },
  data() {
    return {
      myData: this.data,
      selectAll: false,
    };
  },
  computed: {},
  watch: {
    data(newVal) {
      this.myData = newVal;
    },
  },
  created() {},
};
</script>
